module.exports = __webpack_public_path__ + "static/media/alert.a2356a3a.svg";